module.exports = "/assets/data/8d286edbab3a383b77960bdf7d1f6d71-SY20.data.json";